import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-item/task-list.module.css";

export default {
  "barLabel": "task-list-module__barLabel_bW1Sma__100",
  "barLabelOutside": "task-list-module__barLabelOutside_bW1Sma__100"
};
      